import React, { useEffect, useState } from 'react'
import CanvasDraw from "react-canvas-draw"
import dayjs from 'dayjs'
import qs from 'query-string'

import { req, sides, resourceUrl } from '../../util'

import { decompressFromUTF16 } from 'lz-string'

function index() {

    const [car, setCar] = useState(null)
    const [err, setErr] = useState(undefined)

    useEffect(() => {
        let { token } = qs.parse(window.location.search)
        req("GET", `car/ver?token=${token}`, undefined, false, false).then(r => {
            let { err, data } = r
            if (data) setCar({ ...data })
            if (err) setErr(err)
        }).catch(e => {
            setErr("error")
            console.log(e)
        })
    }, [window.location.search])


    return (
        <div className="container mx-auto p-4">
            <div className='text-center text-lg'>بدي كار لفحص السيارات</div>
            {err &&
                <>
                    <div className='text-center text-lg my-10'>
                        لا يمكن التحقق من الشفرة تأكد من مصدر التقرير
                    </div>
                    <div className='homePage'></div>
                </>
            }
            {car &&
                <>
                    <div className="text-center text-xl font-normal text-gray-800 my-2">تقرير العجلة</div>
                    <div className="text-center text-lg font-semibold text-gray-800">{car?.brand} {car?.model} {car?.year}  # {car?.id}</div>
                    <div className="text-center text-lg font-semibold text-gray-800">{dayjs(car?.created_at).format("YYYY-MM-DD")} - {dayjs(car?.created_at).format("a hh:mm")}</div>
                    {Object.keys(sides).map(k => {
                        return (
                            <div key={k} className="my-4 py-3">
                                <div className="flex justify-center">
                                    <CanvasDraw
                                        hideGrid={true}
                                        disabled
                                        lazyRadius={0}
                                        brushRadius={8}
                                        canvasWidth="720px"
                                        loadTimeOffset={0}
                                        backgroundColor="#cbd5e0"
                                        imgSrc={`${resourceUrl}/img/${car[`${k}`]}`}
                                        saveData={car?.imgs[k] ? decompressFromUTF16(car?.imgs[k]) : ""}
                                        hideInterface
                                    />
                                </div>
                                <div>
                                    <div className="my-1 text-lg font-normal">{sides[k]}</div>
                                    <textarea
                                        placeholder={sides[k]}
                                        className="bg-gray-300 w-full p-2 text-lg font-semibold"
                                        rows={3}
                                        defaultValue={car?.report[`${k}Note`]}
                                        disabled
                                    />
                                </div>
                            </div>
                        )
                    })}
                </>
            }
        </div>
    )
}

export default index
